export enum PageUrl {
    ACCOUNT_SHOW = 'Account-Show',
    LOGOUT = 'Login-Logout',
    CART = 'Cart-Show',
    WISHLIST = 'Wishlist-Show',
    SEARCH_SHOW = 'Search-Show',
    PRODUCT_SHOW = 'Product-Show',
    STORES_FIND = 'Stores-Find',
    ORDERS_HISTORY = 'Order-History',
    GIFT_REGISTRY_START = 'GiftRegistry-Start',
    GIFT_REGISTRY_SUBMIT_FORM = 'GiftRegistry-SubmitForm',
    GIFT_REGISTRY_SUBMIT = '/giftregistry-submit',
    TURN_TO = 'TurnTo-CheckoutCommentsPinboard',
    PAGE_SHOW = 'Page-Show',
    LOGIN_SHOW = 'Login-Show',
    LOGIN_FORM = 'Login-LoginForm',
    CUSTOMER_CONTACT_US = 'CustomerService-ContactUs',
    SITE_MAP = 'SiteMap-Start',
    CHECKOUT = '/checkout',
    STORES = '/locations', // This at least should end with '/locations' due to RIO implementation
    CHECKOUT_LOGIN = '/checkout/login',
    CHECKOUT_BILLING = '/checkout/billing',
    CHECKOUT_REVIEW = '/checkout/review',
    CHECKOUT_SHIPPING = '/checkout/shipping',
    HOME = '', // This is not an SFCC URL!!
    HOME_SHOW = 'Home-Show',
    PDP = '/product/:pageURL/:sku',
    PRODUCTS = '/products',
    PWA_PRODUCTS = '/pwa/products',
    SALE = '/sale',
    PWA_SALE = '/pwa/sale',
    NEW = '/new',
    PWA_NEW = '/pwa/new',
    SEARCH = '/search',
    SG_PDP = '/product/*.html',
    ADD_TO_REGISTRY = 'GiftRegistry-AddProduct',
    SG_CART = '/shopping-cart',
    PWA_CART = '/shopping-bag',
    PRODUCT = '/product',
    BUILD_STATUS = '/build-status',
    PERKS = '/perks',
    COMPARE_PRODUCTS = '/compare',
    ACCOUNT = '/account',
    ACCOUNT_LOGIN = '/account/login',
    ACCOUNT_REGISTRATION = '/account/registration',
    ACCOUNT_FORGOT_PASSWORD = '/account/forgot-password',
    ACCOUNT_RESET_PASSWORD = '/account/reset-password',
    TRACK_ORDER = '/account/track-order',
    GIFT_CARDS = '/gifts/gift-cards',
    ELECTRONIC_GIFT_CARD_PAGE = '/product/electronic-gift-card/:sku',
    PHYSICAL_GIFT_CARD_PAGE = '/product/traditional-gift-card/:sku',
    INIT_PWA = '/pwa/init',
}
